import { generateApiRoute } from '@klp/core/api/helpers';
import { getRequiredConfig } from '@klpkonsern/appconfig';
export const ContractRegistrationAccess = () =>
    getRequiredConfig('WEBAPP_CONTRACTREGISTRATION_ENABLE');

export const ContractCutOffMonths = () =>
    getRequiredConfig('WEBAPP_CONTRACT_CUT_OFF_MONTHS');

export const contractToRegistrationApiName = 'kontraktsforvaltning';
export const contractToRegistrationProcessApiName = 'process';
export const avsjekkApiName = 'avsjekk';
export const kontraktDokumentApiName = 'kontraktdokument';
export const filApiName = 'fil';
export const oppsummeringApiName = 'oppsummering';
export const processApiName = 'process';
export const instanceApiName = 'instance';
export const contractToRegistrationStatus = 'storedSelectedStatus';
export const baseUrl = getRequiredConfig('WEBAPP_API_URL');

export const hubEndpoint = 'processchangedhub';

export const contractToRegistrationApiRoutes = {
    download: (dokumentId: string) =>
        generateApiRoute([
            contractToRegistrationApiName,
            kontraktDokumentApiName,
            dokumentId,
            filApiName,
        ]),
};

export enum localStorageReferences {
    CONTRACT_REGISTRATION_FILTERS = 'contractRegistrationFilters',
}
